import { render } from "./ConfigurationToogles.vue?vue&type=template&id=0c056642&scoped=true"
import script from "./ConfigurationToogles.vue?vue&type=script&lang=js"
export * from "./ConfigurationToogles.vue?vue&type=script&lang=js"

import "./ConfigurationToogles.vue?vue&type=style&index=0&id=0c056642&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c056642"]])

export default __exports__
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QToggle});
